import React from 'react'
import { Box, CardHeader, CircularProgress, Typography } from '@mui/material'
import type { CardViewMode } from '@edge/spark/io-dashboards'
import { MUIRouterLink } from '@edge/spark/ui'
import { WidgetMenuIcon } from './WidgetMenuIcon'

interface HeaderProps {
    cardHeaderText: string
    progress?: number
    loading?: boolean
    widgetId: string
    handleConfig?: (widgetId: string) => void
    cardViewMode: CardViewMode
    readonly: boolean
    href?: string
}

interface CardLinkProps {
    cardHeaderText: string
    href: string
}

const CardLink: React.VFC<CardLinkProps> = ({ cardHeaderText, href }: CardLinkProps) => (
    <MUIRouterLink href={href}>
        <Box>
            <Typography
                variant="subtitle2"
                sx={{
                    color: '#F2A86D',
                    fontWeight: 'bold',

                    // Single line ellipsis
                    // overflow: 'hidden',
                    // textOverflow: 'ellipsis',
                    // whiteSpace: 'nowrap',

                    // 2 lines then ellipsis
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                }}
            >
                {cardHeaderText}
            </Typography>
        </Box>
    </MUIRouterLink>
)

export const WidgetCardHeader: React.VFC<HeaderProps> = ({
    cardHeaderText,
    progress,
    loading,
    widgetId,
    handleConfig,
    cardViewMode,
    readonly,
    href,
}: HeaderProps) => {
    return (
        <CardHeader
            sx={{
                fontSize: '13px',
                lineHeight: '15px',
                p: 0,
                fontWeight: 'bold',
            }}
            titleTypographyProps={{
                variant: 'subtitle2',
                color: '#F2A86D',
                sx: {
                    textOverflow: 'ellipsis',
                    maxWidth: 'auto',
                    '.MuiCardHeaderAction': {
                        m: 0,
                    },
                },
            }}
            title={<CardLink cardHeaderText={cardHeaderText} href={href || '#'} />}
            action={
                loading || (progress && progress < 1) ? (
                    <CircularProgress
                        sx={{ m: '10px' }}
                        size={15}
                        variant={progress ? 'determinate' : 'indeterminate'}
                        value={progress ? progress * 100 : undefined}
                    />
                ) : (
                    <WidgetMenuIcon
                        handleConfig={handleConfig}
                        widgetId={widgetId}
                        cardViewMode={cardViewMode}
                        readonly={readonly}
                    />
                )
            }
        />
    )
}
